/* eslint-disable global-require */

export default {
  homescapes: [
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-05.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-06.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/homescapes/preview/ru/preview-07.webp'),
    },
  ],
  township: [
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ru/preview-01.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ru/preview-02.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ru/preview-03.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ru/preview-04.webp'),
    },
    {
      type: 'image',
      link: require('@/assets/images/township/preview/ru/preview-05.webp'),
    },
  ],
};
